/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DelegationStatus } from '../../models/delegation-status';

export interface ExportDelegationReport$Params {

/**
 * sort
 */
  sort?: string;
  search?: string;

/**
 * filter delegations based on created at
 */
  startDate: string;

/**
 * filter delegations based on created at
 */
  endDate: string;
  delegator?: Array<number>;
  delegate?: Array<number>;
  status?: Array<DelegationStatus>;
}

export function exportDelegationReport(http: HttpClient, rootUrl: string, params: ExportDelegationReport$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportDelegationReport.PATH, 'get');
  if (params) {
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('delegator', params.delegator, {});
    rb.query('delegate', params.delegate, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportDelegationReport.PATH = '/api/administration/reports/delegation/export';
